export const skills = {
    languages: ['C', 'C++', 'C#', 'Java', 'Python', 'JavaScript', 'TypeScript'],
    webMobile: ['HTML', 'CSS', 'React', 'React Native', '.NET', 'ASP.NET'],
    systems: ['Operating Systems', 'Computer Networks', 'Git', 'GitHub'],
    databases: ['SQL', 'Firebase'],
    tools: ['Visual Studio', 'Eclipse', 'Microsoft 365']
  };